// extracted by mini-css-extract-plugin
export default {"header":"style_header__yWNIu","title":"style_title__cFS8Z","deleteButton":"style_deleteButton__SNY5K"};